import { render, staticRenderFns } from "./ShopBundleProductRecord.vue?vue&type=template&id=4051d372"
import script from "./ShopBundleProductRecord.vue?vue&type=script&lang=js"
export * from "./ShopBundleProductRecord.vue?vue&type=script&lang=js"
import style0 from "./ShopBundleProductRecord.vue?vue&type=style&index=0&id=4051d372&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports